import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { AuthService } from '../services/auth.service';
import { Title } from '@angular/platform-browser';
import { Config } from '../../config/config';
import { Subscription } from 'rxjs';
import { CauHinhCoQuanService } from '../he-thong/cau-hinh-co-quan/cau-hinh-co-quan.service';
import { CauHinhCoQuan } from '../he-thong/cau-hinh-co-quan/cau-hinh-co-quan';

var Base64 = require('js-base64').Base64;

@Component({
    selector: 'vnpt-login',
    templateUrl: './login.component.html',
    providers: [LoginService, CauHinhCoQuanService]

})
export class LoginComponent implements OnInit {
    busy: Subscription;
    username: any;
    password: any;
    otp: any;
    lt: any;
    jsession: any;
    showOTP: boolean = false;
    try_count: number = 0;
    loginErrorStatus: string = "";
    otp_config: number = 0;
    isSubmit = false;
    isShow = false;

    sso_used: boolean = true;
    detailItem: CauHinhCoQuan;

    constructor(private loginService: LoginService,
        private cauhinhService: CauHinhCoQuanService,
        public authService: AuthService,
        private router: Router,
        private titleService: Title) {
        titleService.setTitle("Đăng nhập hệ thống");
    }

    ngOnInit() {        
        this.authService.isLoggedIn = false;
        this.loginErrorStatus = "";        
        this.cauhinhService.GetOTP().subscribe(
            (data) => {                
                this.detailItem = data;                               
                if (!data || data.length <= 0) {

                } else {                    
                    var id_token = localStorage.getItem("scnnttidtoken");
                    var token = localStorage.getItem("scnntttoken");
                    //this.router.navigate(['xl-xu-ly-su-co/xu-ly-su-co-new']);
                    this.detailItem = data;
                    this.sso_used = this.detailItem.SSO;
                    if (this.detailItem.SSO) {
                        // window.location.href = Config.sso;
                        if (token && !id_token) {
                            //login bí mật
                            this.authService.isLoggedIn = true;
                            // this.router.navigate(['xl-xu-ly-su-co/xu-ly-su-co-new']);
                            this.router.navigate(['phan-anh/browse']);
                        } else {
                            window.location.href = Config.sso;
                        }
                    } else {
                        if (token) {
                            //login bí mật
                            this.authService.isLoggedIn = true;
                            // this.router.navigate(['xl-xu-ly-su-co/xu-ly-su-co-new']);
                            this.router.navigate(['phan-anh/browse']);
                        } else {
                            this.router.navigate(['loginvnpt']);
                        }
                    }
                }
            },
            er => {

            });
    }

    login() {
        this.isSubmit = true;
        this.loginErrorStatus = "Đang kiểm tra dữ liệu vui lòng đợi...";
        this.busy = this.loginService.login(this.username, this.password)
            .subscribe(
            (data) => {                
                this.doLogin(data);
            },
            (e) => {
                this.loginErrorStatus = "Lỗi: Tên đăng nhập/mật khẩu không đúng";
                console.log(e);
                this.isSubmit = false;
                this.isShow = true;
            })

    }

    doLogin(data) {
        localStorage.setItem("scnntttoken", data.access_token);
        localStorage.setItem("expires", data[".expires"]);
        this.authService.getUserRolesInfo(data.access_token, "quyen").subscribe(
            (info: any) => {
                this.authService.dsRoutes = info.routesInfo;
                this.authService.user = info.userInfo;
                var jsonString = JSON.stringify(info);
                var encodedString = Base64.encode(jsonString);
                localStorage.setItem("userInfo", encodedString);
                if (this.authService.redirectUrl == null || this.authService.redirectUrl == undefined)
                // this.router.navigate(['./xl-xu-ly-su-co/xu-ly-su-co-new']);
                this.router.navigate(['./phan-anh/browse']);
                else
                    this.router.navigate([this.authService.redirectUrl]);
                this.authService.isLoggedIn = true;
                this.registerServiceWorker();

            },
            (e) => {
                this.loginErrorStatus = "Lỗi: Hệ thống có lỗi, xin vui lòng quay lại sau";
                console.log(e);
            });
    }
    registerServiceWorker() {
        this.authService.getWebPushKey().subscribe(
            (data) => {
                console.log(data);
                if (data) {
                    navigator.serviceWorker.register('assets/js/sw.js').then(registration => {
                        //console.log('Service Worker is registered', registration);
                        registration.pushManager.subscribe({
                            userVisibleOnly: true, applicationServerKey: this.urlB64ToUint8Array(data)
                        }).then(subscription => {
                            //console.log('User is subscribed.');
                            console.log(JSON.stringify(subscription));
                            this.authService.setSubscription(JSON.stringify(subscription)).subscribe(
                                (data) => {
                                    console.log(data)
                                });
                        }).catch(err => {
                            this.authService.deleteSubscription().subscribe(
                                (data) => {
                                    //this.registerServiceWorker();
                                    registration.pushManager.subscribe({
                                        userVisibleOnly: true, applicationServerKey: this.urlB64ToUint8Array(data)
                                    }).then(subscription => {
                                        //console.log('User is subscribed.');
                                        console.log(JSON.stringify(subscription));
                                        this.authService.setSubscription(JSON.stringify(subscription)).subscribe(
                                            (data) => {
                                                console.log(data)
                                            });
                                    }).catch(err => {
                                        this.authService.deleteSubscription().subscribe(
                                            (data) => {
                                                //this.registerServiceWorker();
                                            });
                                    })
                                });
                        })
                    }).catch(err => {
                        navigator.serviceWorker.ready.then(registration => {
                            registration.pushManager.subscribe({
                                userVisibleOnly: true, applicationServerKey: this.urlB64ToUint8Array(data)
                            }).then(subscription => {
                                this.authService.setSubscription(JSON.stringify(subscription)).subscribe(
                                    (data) => {
                                        console.log(data)
                                    });
                            }).catch(err => {
                                console.log('Failed to subscribe the user: ', err);
                                this.authService.deleteSubscription().subscribe(
                                    (data) => {
                                        console.log(data)
                                    });
                            })
                        }).catch(err => {
                            console.log(`Could not register service worker. Reason: ${err}`);
                        });
                    });

                }
            }
        );
    }
    urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/login/login.component.ts